module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_5_C_1.4294aaaa.mp3";